var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreNative = function SvgMoreNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.25v3.5h-3.5v-3.5h3.5ZM13.75 10.25v3.5h-3.5v-3.5h3.5ZM13.75 17.25v3.5h-3.5v-3.5h3.5Z",
    fill: "#666"
  })));
};
export default SvgMoreNative;